import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, auth } from '../lib/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // Resolves the NoCodeBackend session cookie into { user, profile }. The server
  // creates the app profile on first sign-in, so there is nothing to insert here.
  const refreshSession = useCallback(async () => {
    try {
      const me = await api('me');
      setUser(me.user);
      setProfile(me.profile);
      return me.user;
    } catch (err) {
      if (err.status !== 401) console.error('Session load error:', err.message);
      setUser(null);
      setProfile(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  const signOut = async () => {
    setUser(null);
    setProfile(null);
    try {
      await auth('sign-out', {});
    } catch (err) {
      console.error('Sign out error:', err.message);
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      profile,
      loading,
      signOut,
      refreshSession,
      refreshProfile: refreshSession
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
